import React, {useState} from "react";
import {service as UserAPIKeyService} from "../../../../Services/UserAPIKeyService";
import {Glyphicon} from "../../GlyphIcon";
import {ConfirmationDialog} from "../../ConfirmationDialog";

/**
 * Revoke button rendered per-row by MutableList in edit mode.
 * Shows a confirmation dialog before revoking.
 * Calls the API directly, then invokes onRemove() to remove the key from local state.
 */
export const RevokeUserAPIKeyButton = (props) => {

    const {
        item,
        onRemove = () => {},
    } = props;

    const [confirming, setConfirming] = useState(false);
    const [revoking, setRevoking] = useState(false);

    const handleRevoke = async () => {
        if (revoking) return;
        setRevoking(true);
        setConfirming(false);
        try {
            await UserAPIKeyService.RevokeApiKey(item.userApiKeyId);
            onRemove();
        } catch (e) {
            // leave key in list if revocation failed
            setRevoking(false);
        }
    };

    return (
        <>
            <div className="remove-table pop-remove">
                <a className={"pndlm-remove-control" + (revoking ? " disabled" : "")} onClick={() => setConfirming(true)}>
                    <Glyphicon glyph="remove-sign"/>
                </a>
            </div>
            <ConfirmationDialog
                Display={confirming}
                Title="Revoke API Key"
                Body={<p>Are you sure you want to revoke <strong>{item.name}</strong>? This cannot be undone.</p>}
                CancelButtonMessage="Cancel"
                ConfirmationButtonMessage="Revoke"
                OnClose={() => setConfirming(false)}
                OnHide={() => setConfirming(false)}
                OnConfirm={handleRevoke}
            />
        </>
    );
};